import styled from "styled-components";
import {
  sharedFontCss,
  TypographyProps,
} from "@shared/common/Typography/Typography";
import { typography } from "@shared/common/Themes/typography";

const Typography = styled.div.attrs<TypographyProps>((p) => ({
  type: p.type ?? "primary",
  $ellipsis: p.$ellipsis ?? false,
}))<TypographyProps>`
  ${sharedFontCss};
  font-weight: ${(p) => p.$weight || typography.fontWeights.NORMAL};
  font-family: ${(p) => p.theme.typography.fontFamily};
  transition: color 0.35s;
  ${(p) =>
    p.$ellipsis &&
    `
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
  `}
`;

export default Typography;
